import { Link } from 'react-router-dom';
import { useState } from 'react';


import './BookingForm/PartyForm.css';
import './BookingForm/Feed.css'
import './BookingForm/FloatingLabelInput.css';
import './BookingForm/FloatingLabelSelect.css';

import Rectangle from "./image/Rectangle.png"
import feed1 from "./image/feed-1.png"
import feed2 from "./image/feed-2.png"
import feed3 from "./image/feed-3.png"
import feed from "./image/feed.jpg"



import PackageLaedFormComp from "./PackageLaedFormComp";




function GroupBooking({ clubId }) {

  const [activeTab, setActiveTab] = useState("package");
  const [imageload, setimageload] = useState(true);


  return (
    <div className="Package-lead-page-container">
      <div>
        <div className="feed-section-container">
          <div className="feed-section-container-sec-nav">
          </div>
          <div className='feed-section'>
            <div className='feed-section-img feed-image-wrapper'>
              <div className="feed-img-section">
                <>
                  {imageload && <div className='feed-shimmer-box'></div>}

                  <img
                    src={feed}
                    alt="Reserve Party Packages with Food & Drinks Nearby"
                    style={{ display: imageload ? "none" : "block" }} // hide real image until loaded
                    onLoad={() => setimageload(false)}
                    onError={() => setimageload(false)} // also hide shimmer if image fails
                  />
                </>

                <div className='feed-img-overlay'>
                  <h1>Party Planning <span className='feed-img-overlay-span'>Just Got Smarter</span></h1>
                  <div className='feed-img-overlay-list'>
                    <div className='custom-image-list'>
                      <div className='custom-image'><img src={Rectangle} alt="" /> </div>
                      <span>Post your party plan</span>
                    </div>
                    <div className='custom-image-list'>
                      <div className='custom-image'><img src={Rectangle} alt="" /> </div>
                      <span>Let Venues Bid to Host it</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='feed-form-section'>
              <div className="tabs-sec-nav">
                <Link to='/package-lead-form'>
                  <div
                    className={`tabs-sec-nav-box ${activeTab === "package" ? "active" : ""}`}
                    onClick={() => setActiveTab("package")}
                  >
                    <h1>Party Package</h1>
                  </div>
                </Link>
                <Link to='/table-book-form'>
                  <div
                    className={`tabs-sec-nav-box ${activeTab === "table" ? "active" : ""}`}
                    onClick={() => setActiveTab("table")}
                  >
                    <h1>Table Reservation</h1>
                  </div>
                </Link>
              </div>
              <h2>Tell Us When Is The Party</h2>
              <>
                <PackageLaedFormComp />
              </>
            </div>
          </div>
          <div>
            <div className='container'>
              <div className='f-feed'>
                <div className='f-feed-line'>
                  <div className='f-feed-text'>
                    <h1>1000+</h1>
                    <p>Clubs </p>
                  </div>
                  <div className='f-feed-img'>
                    <img src={feed1} alt="" />
                  </div>
                </div>
                <div className='v-line'></div>
                <div className='f-feed-line'>
                  <div className='f-feed-text'>
                    <h1>5,000 +</h1>
                    <p>F&B Packages </p>
                  </div>
                  <div className='f-feed-img'>
                    <img src={feed2} alt="" />
                  </div>
                </div>
                <div className='v-line'></div>

                <div className='f-feed-line'>
                  <div className='f-feed-text'>
                    <h1>12,000 +</h1>
                    <p>Happy Customers </p>
                  </div>
                  <div className='f-feed-img'>
                    <img src={feed3} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='package-page-design-bottom-footer-tags-section'>
            <div className='package-page-detail-page-design-bottom-footer-tags'>
              <div className='package-page-detail-page-design-bottom-footer-tags-text'>
                <h1>Book Party Packages with Food & Drinks in Delhi NCR</h1>
                <p>Looking to book party packages with food and drinks in Delhi NCR? PartyWitty brings you the best deals on birthday party packages, bachelor party combos, and group event bookings. Choose from top-rated venues offering delicious cuisines, premium drinks, and exciting ambiance. Whether it’s a private celebration or a corporate bash, find the perfect party package tailored to your needs. Enjoy seamless venue booking, live availability, and amazing discounts – all in one place. Book now and party smarter with PartyWitty!</p>
              </div>
            </div>
          </div>
          
        </div>

      </div>
    </div>
  );
}

export default GroupBooking;

